import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, unref as _unref, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f45b683c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "live-message-templates",
  class: "main-content-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "main-content-page-title" }, "定型文一覧", -1))
const _hoisted_3 = { class: "live-message-templates-body" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "w-full text-right pr-4" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["onClick"]

import { onBeforeMount, ref, inject, computed } from "vue";
import { get, set } from "@vueuse/core";
import { PageState } from "primevue/paginator";
import { useConfirm } from "primevue/useconfirm";
import { useToast } from "primevue/usetoast";
import Toast from "primevue/toast";
import { DEFAULT_PAGINATOR_ROWS } from "@/clinic/typings/constants/paginator";
import Header from "@/clinic/components/atoms/Grid/header.vue";
import Grid from "@/clinic/components/atoms/Grid/index.vue";
import Paginator from "@/clinic/components/atoms/Paginator/index.vue";
import RouterUtils from "@/common/utils/router.util";
import RouterConstants from "@/clinic/constants/router.constants";
import { LiveMessageTemplateServices } from "@/clinic/services";
import type { ApiBasePaginatorReq, ApiLiveMessageTemplateIndexReq, ApiLiveMessageTemplateReq } from "@/clinic/typings";
import { notifySuccessMsg } from "@/clinic/utils/notify-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const confirm = useConfirm();
const toast = useToast();

const clinicId = ref(0);
const loading = ref(true);
const templates = ref([]);
const columns = ref([
  { field: "title", header: "タイトル" },
  { field: "content", header: "メッセージ" },
  { field: "actions", header: "" },
]);
const searchTerm = ref("");
const rows = ref(DEFAULT_PAGINATOR_ROWS);
const totalCount = ref(0);
const page = ref(0);
const pgTop = ref<InstanceType<typeof Paginator> | null>(null);
const pgBot = ref<InstanceType<typeof Paginator> | null>(null);

const paginatorParams = computed(
  (): ApiBasePaginatorReq => ({ term: get(searchTerm), page: get(page), rows: get(rows) } as ApiBasePaginatorReq)
);

const fetchTemplates = async () => {
  set(loading, true);
  const { data } = await LiveMessageTemplateServices.fetchTemplates(
    { ...{ clinic_id: get(await get(clinicId)) }, ...get(paginatorParams) } as ApiLiveMessageTemplateIndexReq,
    () => undefined,
    () => undefined,
    () => set(loading, false)
  );
  set(templates, data.value.templates);
  set(totalCount, data.value.meta.total_count);
};

const paging = async (fromId: string, { page: newPage }: PageState) => {
  const pgRef = fromId == "pg-top" ? get(pgBot)?.getPagination() : get(pgTop)?.getPagination();
  if (newPage == pgRef?.page) return;

  get(pgRef)?.changePage(newPage);
  set(page, newPage);
  await fetchTemplates();
};

const onSearch = async event => {
  set(searchTerm, event.currentTarget?.value);
  set(page, 0);
  await fetchTemplates();
};

const moveToNewTemplate = () => {
  RouterUtils.goTo(RouterConstants.LIVE_MESSAGE_TEMPLATE_NEW_ROUTER_NAME);
};

const editTemplate = (event, templateId) => {
  event.stopPropagation();
  RouterUtils.goToWithParams(RouterConstants.LIVE_MESSAGE_TEMPLATE_EDIT_ROUTER_NAME, { id: templateId });
};

const deleteTemplate = async (event, templateId) => {
  event.stopPropagation();

  confirm.require({
    message: "この定型文を削除しますか?",
    header: "定型文を削除",
    rejectLabel: "キャンセル",
    acceptLabel: "削除",
    acceptClass: "p-button-danger",
    accept: async () => {
      await LiveMessageTemplateServices.deleteTemplate(
        { ...{ clinic_id: get(await get(clinicId)) }, ...{ id: templateId } } as ApiLiveMessageTemplateReq,
        async () => {
          notifySuccessMsg(toast, "正常に削除されました");
          await fetchTemplates();
        },
        () => undefined
      );
    },
  });
};

onBeforeMount(async () => {
  set(clinicId, await inject("clinicId"));
  fetchTemplates();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(Header, {
      enableSearch: "",
      onSearch: onSearch,
      onNew: moveToNewTemplate,
      createButtonLabel: "作成",
      searchPlaceholder: "タイトルを入力"
    }),
    _createElementVNode("div", _hoisted_3, [
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 0,
            id: "pg-top",
            ref_key: "pgTop",
            ref: pgTop,
            modelValue: _ctx.first,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.first) = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true),
      _createVNode(Grid, {
        items: templates.value,
        columns: columns.value,
        loading: loading.value
      }, {
        content: _withCtx(({ data }) => [
          _createElementVNode("div", {
            class: "content-wrapper",
            innerHTML: data.content
          }, null, 8, _hoisted_4)
        ]),
        actions: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", {
              class: "pi pi-pencil text-green-600 mr-4",
              onClick: ($event: any) => (editTemplate($event, data.id))
            }, null, 8, _hoisted_6),
            _createElementVNode("span", {
              class: "pi pi-trash text-red-600",
              onClick: ($event: any) => (deleteTemplate($event, data.id))
            }, null, 8, _hoisted_7)
          ])
        ]),
        _: 1
      }, 8, ["items", "columns", "loading"]),
      (totalCount.value > rows.value)
        ? (_openBlock(), _createBlock(Paginator, {
            key: 1,
            id: "pg-bot",
            ref_key: "pgBot",
            ref: pgBot,
            modelValue: _ctx.first,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.first) = $event)),
            onPaging: paging,
            totalRecords: totalCount.value,
            rows: rows.value,
            class: "mt-2"
          }, null, 8, ["modelValue", "totalRecords", "rows"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_unref(Toast), { position: "top-center" })
  ]))
}
}

})